<template>
  <div class="ugo-form-field">
  <FormViewItem v-if="as_view" :label="label" :required="!!required">
    <span class="ugo-form-view-text" :class="{ 'ugo-form-view-empty': viewDisplayText === '未填写' }">{{ viewDisplayText }}</span>
  </FormViewItem>
  <FormItem v-else :label="label" :required="!!required">
  <template v-if="editable">
      <DatePicker format="yyyy/MM/dd" v-model="formattedValue" transfer :placeholder="config?.placeholder || '请选择'" />
  </template>
  <template v-else>
    <div style="color:#aaa;min-width:140px;text-align:center;">
      {{viewDisplayText}}
    </div>
  </template>
  </FormItem>
  </div>
</template>

<script>
import moment from 'moment';
import defaultValueMixin from '../mixins/default-value';
import valueDefMixin from '../mixins/value-def';
import asViewMixin from '../mixins/as-view';
export default {
  mixins: [defaultValueMixin, valueDefMixin, asViewMixin],
  methods: {
    getValueDef() {
      return this.valueDefString();
    },
  },
  cname: '日期',
  corder: 31,
  icon: 'xuanzeriqi',
  props: ['value', 'label', 'config', 'editable', 'required'],
  properties: [{
    label: '提示文字',
    key: 'placeholder',
    control: 'Text',
  }],
  computed: {
    viewDisplayText() {
      return this.value ? moment(this.value).format('YYYY/MM/DD') : '未填写';
    },
    formattedValue: {
      get() {
        if (!this.value || !moment(this.value).isValid()) {
          return '';
        }
        return this.value?new Date(moment(this.value).valueOf()):'';
      },
      set(v) {
        this.$emit('input', v?moment(new Date(v)).format('YYYY-MM-DD'):'');
      },
    },
  },
};
</script>

<style lang="less" scoped>

</style>
